import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const BootcampPromoSection = () => {

  const navigate = useNavigate();

  return (

    <section className="py-16 bg-card border-t border-b">

      <div className="max-w-7xl mx-auto px-4 text-center">

        <div className="flex justify-center items-center gap-3 mb-4">
          <Icon name="GraduationCap" size={36} />
          <h2 className="text-3xl font-heading font-bold">
            Live Bootcamps
          </h2>
        </div>

        <p className="text-muted-foreground max-w-2xl mx-auto mb-8">
          Join our instructor-led bootcamps to master Python, SQL, and
          interview-ready skills in just a few hours.
        </p>

        <button
          onClick={() => navigate("/bootcamp")}
          className="bg-primary text-white px-8 py-3 rounded-lg text-lg hover:opacity-90"
        >
          Explore Bootcamps
        </button>

      </div>

    </section>

  );

};

export default BootcampPromoSection;